import { API } from '@/api/Api'
import { AiChatSession } from '@/ai/model/AiChatSession'
import { AiChatMessage } from '@/ai/model/AiChatMessage'
import { AiChatGreeting } from '@/ai/model/AiChatGreeting'
import { AiChatSuggestion } from '@/ai/model/AiChatSuggestion'

export const AssistantApi = {

  async getChatSessions (accountId, userId, limit = null) {
    const response = await API.Resource.AiAssistant.getChatSessions(accountId, userId, limit)
    const data = API.responseData(response)?.chatSessions || null
    const errors = API.responseErrors(response) || []

    if (API.isResponseSuccess(response) && data) {
      return data.map(session => new AiChatSession(session))
    } else {
      throw new Error(errors)
    }
  },

  async getChatMessages (accountId, sessionId) {
    const response = await API.Resource.AiAssistant.getChatMessages(accountId, sessionId)
    const data = API.responseData(response)?.chatMessages || null
    const errors = API.responseErrors(response) || []

    if (API.isResponseSuccess(response) && data) {
      return data.map(message => new AiChatMessage(message))
    } else {
      throw new Error(errors)
    }
  },

  async getChatGreeting (accountId, userId) {
    const response = await API.Resource.AiAssistant.getChatGreeting(accountId, userId)
    const data = API.responseData(response)?.chatGreeting || null
    const errors = API.responseErrors(response) || []

    if (API.isResponseSuccess(response) && data) {
      return new AiChatGreeting(data)
    } else {
      throw new Error(errors)
    }
  },

  async getChatSuggestions (accountId, page) {
    const response = await API.Resource.AiAssistant.getChatSuggestions(accountId, page)
    const data = API.responseData(response)?.chatSuggestions || null
    const errors = API.responseErrors(response) || []

    if (API.isResponseSuccess(response) && data) {
      return data.map(message => new AiChatSuggestion(message))
    } else {
      throw new Error(errors)
    }
  },

  async deleteChatSession (userId, accountId, sessionId) {
    const response = await API.Resource.AiAssistant.deleteChatSession(userId, accountId, sessionId)
    const data = API.responseData(response)?.deleteChatSession || null
    const errors = API.responseErrors(response) || []

    if (API.isResponseSuccess(response) && data) {
      return data
    } else {
      throw new Error(errors)
    }
  }

}
